import { useState } from "react";
import { FileSpreadsheet, Loader2, Star, Trash2 } from "lucide-react";
import { saveBlob } from "@/lib/download";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";

export const PesertaFeedback = ({ kajian, onChange }) => {
  const api = useApi();
  const items = kajian.maklum_balas || [];
  const [dl, setDl] = useState(false);
  const exportXlsx = async () => {
    setDl(true);
    try { saveBlob(await api("get", `/hte/kajian/${kajian.id}/maklum-balas.xlsx`, null, { responseType: "blob" }), `Maklum Balas - ${kajian.tajuk}.xlsx`); }
    catch (e) { toast.error(errMsg(e)); } finally { setDl(false); }
  };
  if (!items.length) return <p className="text-sm text-mute" data-testid="peserta-feedback-empty">Belum ada maklum balas peserta. Kongsi pautan peserta untuk mengumpul maklum balas.</p>;
  const avg = items.reduce((a, m) => a + m.penilaian, 0) / items.length;
  const remove = async (m) => {
    if (!window.confirm("Padam maklum balas ini?")) return;
    try { await api("delete", `/hte/kajian/${kajian.id}/maklum-balas/${m.id}`); onChange({ maklum_balas: items.filter((x) => x.id !== m.id) }); toast.success("Dipadam"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="peserta-feedback">
      <div className="flex items-center gap-2 text-sm" data-testid="peserta-feedback-avg"><Star size={16} className="fill-[var(--q)] text-q" /><strong className="text-ink">{avg.toFixed(1)} / 5</strong><span className="text-mute">daripada {items.length} maklum balas</span>
        <button onClick={exportXlsx} disabled={dl} data-testid="peserta-feedback-xlsx" className="ml-auto h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-surface disabled:opacity-40">{dl ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />} Muat turun Excel</button></div>
      <ul className="space-y-2">
        {[...items].reverse().map((m) => (
          <li key={m.id} className="rounded-xl border border-line p-4 text-sm space-y-1" data-testid={`peserta-feedback-${m.id}`}>
            <div className="flex justify-between gap-2">
              <span className="text-ink"><strong>{"★".repeat(m.penilaian)}{"☆".repeat(5 - m.penilaian)}</strong> {m.nama && `· ${m.nama}`}</span>
              <button onClick={() => remove(m)} aria-label="Padam" data-testid={`peserta-feedback-delete-${m.id}`} className="h-7 w-7 grid place-items-center rounded-full text-mute hover:text-warn"><Trash2 size={13} /></button>
            </div>
            {m.bermanfaat && <p><span className="text-mute">Bermanfaat:</span> {m.bermanfaat}</p>}
            {m.perbaiki && <p><span className="text-mute">Boleh diperbaiki:</span> {m.perbaiki}</p>}
            {m.cadangan && <p><span className="text-mute">Cadangan seterusnya:</span> {m.cadangan}</p>}
            {(m.telefon || m.email) && <p className="text-xs text-mute">{[m.telefon, m.email].filter(Boolean).join(" · ")}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
};
